<template>
  <header class="ca-header">
    <h1 class="ca-header__title">{{ $t('cleaner_activity') }}</h1>

    <span
      v-if="dataStatus"
      class="ca-header__data-status"
      :class="`is-${dataStatus}`"
      role="status"
      :title="updatedTooltip"
    >
      <span class="ca-header__data-dot"></span>
      {{ dataStatusLabel }}
    </span>
  </header>
</template>

<script>
export default {
  props: {
    lastUpdatedLabel: { type: String, default: '' },
    lastUpdatedAbsolute: { type: String, default: '' },
    /** 'live' | 'stale' | 'error' | null */
    dataStatus: { type: String, default: null },
  },
  computed: {
    dataStatusLabel() {
      if (this.dataStatus === 'stale') return this.$t('refresh_failed')
      if (this.dataStatus === 'error') return this.$t('failed_to_load_data')
      return this.$t('cleaner_activity_live_footer')
    },
    /** "Updated: 2m ago (10:42:11)" — the relative time is the headline, the absolute time the detail. */
    updatedTooltip() {
      if (!this.lastUpdatedLabel) return null
      const absolute = this.lastUpdatedAbsolute ? ` (${this.lastUpdatedAbsolute})` : ''
      return `${this.$t('last_updated')}: ${this.lastUpdatedLabel}${absolute}`
    },
  },
}
</script>

<style lang="scss" scoped>
.ca-header {
  display: flex;
  align-items: center;
  gap: 8px 14px;
  flex-wrap: wrap;
  margin-bottom: 14px;

  &__title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
  }

  &__data-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: default;

    &.is-live {
      color: #5f9b46;

      .ca-header__data-dot {
        background-color: #5f9b46;
        animation: ca-header-pulse 1.4s ease-in-out infinite;
      }
    }

    &.is-stale {
      color: #c67c2a;

      .ca-header__data-dot {
        background-color: #e67e22;
        box-shadow: 0 0 0 2px rgba(230, 126, 34, 0.2);
      }
    }

    &.is-error {
      color: #c0392b;

      .ca-header__data-dot {
        background-color: #c0392b;
      }
    }
  }

  &__data-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }
}

@keyframes ca-header-pulse {
  0% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.35; transform: scale(0.8); }
  100% { opacity: 1; transform: scale(1); }
}

@media (prefers-reduced-motion: reduce) {
  .ca-header__data-status.is-live .ca-header__data-dot {
    animation: none;
  }
}

@media (max-width: 767px) {
  .ca-header__title {
    font-size: 1.25rem;
  }
}
</style>
